// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-18e928cd] .dropdown-menu.sidebar-dropdown-links-menu{min-width:275px}", ""]);
// Exports
module.exports = exports;
